angular.module('gestioneAttiApp').directive('decadutoBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/decadutoBlock/decadutoBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            decaduto: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: "=",
            publicView: "=",
            hideEsitoAttoMedatati: "=",
            viewMode: '='
            
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            // vm.decaduto = {visible: true};

            vm.sezioni = {
                DECADUTO: {
                    form: 'app/components/decadutoBlock/decaduto.html'
                }
            };

            vm.stato = {
                decaduto: {
                    isCollapsed: vm.statoAttoCorrente === 'DECADUTO' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];
            //vm.utente = vm.currentUser;
        }]
    };
});
